module.exports = __webpack_public_path__ + "img/icon_home_hezuo_two@3x.6f822649.png";